// src/app/store.js
// src/components/store.js
import { configureStore } from "@reduxjs/toolkit";
import dogReducer from "../components/Items";
import uploadReducer from "../components/uploadSlice";
import imagesReducer from "./imageStore";
import activePetReducer from "./activePetSlice";
import authReducer from "./authSlice"; // ✅ must exist

const store = configureStore({
  reducer: {
    dogs: dogReducer,
    upload: uploadReducer,
    images: imagesReducer,
    activePet: activePetReducer,
    auth: authReducer, // ✅ ensures state.auth exists

  },
});

export default store;
